import {
  Box,
  Button,
  Divider,
  Paper,
  Stack,
  Typography,
  useTheme,
} from "@mui/material";
import KeyboardArrowRightRounded from "@mui/icons-material/KeyboardArrowRightRounded";
import StatusChip from "./StatusChip";
import { Proposal } from "../../../../types/proposal.types";
import { tokens } from "../../../../../../../theme";

interface ProposalCardProps {
  proposal: Proposal;
  onView?: (id: number) => void;
}

export default function ProposalCard({ proposal, onView }: ProposalCardProps) {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  return (
    <Paper
      sx={{
        borderRadius: 3,
        p: 2.5,
        boxShadow: 0,
        bgcolor: "background.paper",
        border: `1px solid ${colors.primary[800]}`,
      }}
    >
      {/* Title + Status */}
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        sx={{ mb: 2 }}
      >
        <Typography sx={{ fontWeight: 700, fontSize: "18px", color: colors.primary[100] }}>
          {proposal.title}
        </Typography>
        <StatusChip status={proposal.status} />
      </Stack>

      {/* Info Row */}
      <Stack direction="row" justifyContent="space-between" sx={{ mb: 2 }}>
        <Box>
          <Typography sx={{ fontSize: "11px", color: colors.primary[100], mb: 0.3 }}>
            Package
          </Typography>
          <Typography sx={{ fontSize: "13px", color: "text.secondary", fontWeight: 500 }}>
            {proposal.packageName}
          </Typography>
        </Box>
        <Box>
          <Typography sx={{ fontSize: "11px", color: colors.primary[100], mb: 0.3 }}>
            Estimate Total
          </Typography>
          <Typography sx={{ fontSize: "13px", color: "text.secondary", fontWeight: 500 }}>
            {proposal.estimateTotal}
          </Typography>
        </Box>
        <Box>
          <Typography sx={{ fontSize: "11px", color: colors.primary[100], mb: 0.3 }}>
            Last Activity
          </Typography>
          <Typography sx={{ fontSize: "13px", color: "text.secondary", fontWeight: 500 }}>
            {proposal.lastActivity}
          </Typography>
        </Box>
      </Stack>

      <Divider sx={{ mb: 1.5, opacity: 0.6 }} />

      {/* View Proposal */}
      <Box sx={{ display: "flex", justifyContent: "center" }}>
        <Button
          onClick={() => onView?.(proposal.id)}
          endIcon={<KeyboardArrowRightRounded />}
          sx={{
            textTransform: "none",
            fontWeight: 600,
            fontSize: "13px",
            color: colors.primary[400],
            p: 0,
            "&:hover": { bgcolor: "transparent", color: colors.primary[500] },
          }}
        >
          View Proposal
        </Button>
      </Box>
    </Paper>
  );
}